// @ts-nocheck
import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../../common/Table';
import { CommaNumber_NoDecimal } from '../../../../util/formatter';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import YesNoLabel from '../../../common/YesNoLabel';
import { useTranslation } from 'react-i18next';
import {
  exportCompanyTypesData,
  getCompanyTypes,
} from '../../../../api/companyTypeApi';

function CompanyTypeList({ reload }) {
  const { t } = useTranslation();
  const allColumns = ['name', 'isDefault', 'companies', 'userProfiles'];
  const defaultVisibleColumns = allColumns;
  const [companyTypes, setCompanyTypes] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const {
    tableSettings,
    handleSetTableSettings: setTableSettings,
    filters,
    filterChange,
    isLoading,
  } = useTableSettings(
    'companytypelist-settings',
    getTableSettingsDefaults({ defaultSort: 'name', defaultVisibleColumns }),
    null,
    getCompanyTypes,
    setCompanyTypes,
    reload,
    t('Failed to load company types')
  );

  // The base config of the columns, this will be filtered based on the visible (above)
  let columnsConfig = [
    {
      Key: 'name',
      Label: t('Name'),
      width: '40%',
      Render: (companyType) => (
        <Link to={'/settings/company-type/' + companyType.id}>
          {companyType.name}
        </Link>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
            testId="company-type-name-filter"
          />
        ),
      },
    },
    {
      Key: 'isDefault',
      Label: t('Is default'),
      width: '10%',
      className: 'no-wrap',
      Render: (companyType) => (
        <YesNoLabel value={companyType.isDefault} emptyOnNo={true} />
      ),
    },
    {
      Key: 'companies',
      Label: t('Number of companies'),
      width: '25%',
      className: 'text-right num no-wrap',
      Render: (companyType) => (
        <NavLink to={`/companies?f_companyTypeId=${companyType.id}`}>
          {CommaNumber_NoDecimal(companyType.companies)}
        </NavLink>
      ),
    },
    {
      Key: 'userProfiles',
      Label: t('Number of users'),
      width: '25%',
      className: 'text-right num no-wrap',
      Render: (companyType) => (
        <NavLink to={`/users/?f_companyTypeId=${companyType.id}`}>
          {CommaNumber_NoDecimal(companyType.userProfiles)}
        </NavLink>
      ),
    },
  ];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return companyTypes ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={companyTypes.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={companyTypes.totalRowCount}
        filteredRowCount={companyTypes.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        exportData={exportCompanyTypesData}
      />
    </KwPanel>
  ) : (
    <Loading />
  );
}

export default CompanyTypeList;
